module.exports = __webpack_public_path__ + "static/media/expand-arrows-alt.bb63dfe0.svg";